import AOS from "aos";
import "aos/dist/aos.css";
import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import "./home.scss";

function Home() {
	AOS.init({
		delay: 500,
		once: true
	});


	return (
		<div className="sec2">
			<div className="container">
				<div className="sec2Head">
					<h1 className="title GGIFont" data-aos="">
						Galaxy Gemological Institute
					</h1>
					<p data-aos="">
					Established in 2013, the Galaxy Gemological Institute (GGI) is a premier gemological institution committed to providing comprehensive services in gemstone testing, education, and certification. Our state-of-the-art laboratories, strategically located in the heart of Karachi's and Peshawar's bustling gem markets, are equipped with the latest technology to ensure accurate and reliable results.
As pioneers in the industry, GGI was the first gemstone testing lab in Pakistan to offer online verification, revolutionizing the way gemstones are authenticated. Our internationally recognized diamond grading reports are trusted by clients worldwide, solidifying our position as the leading diamond testing lab in the country.
Beyond certification, GGI offers a range of educational programs, including gemstone identification, diamond grading, and jewelry design courses. Our commitment to excellence and integrity has earned us a reputation for providing accurate and honest assessments, making us a trusted partner for both industry professionals and discerning consumers.

					</p>
				</div>
				<div className="expertiseRow">
					<div className="center">
						<br/>
						<h2 className="title" >
							GGI Expertise
						</h2>						<br/>

					</div>
					<div className="row" style={{ alignItems: "left", justifyContent: "center" }}>
						<div className="leftpoints col-md-6 col-sm-12">
							<div className="point" data-aos-delay="" data-aos="">
								<div>
								<img
										alt="X-RAY_FLOURESCENSE_sacjur.webp"
										data-src={"https://res.cloudinary.com/ggi/image/upload/v1663153836/Bruker-S1-TITAN-Portable-Spectral-Services-2-scaled-removebg-preview_agybfi.png"}
										className="machine XRF lazy"
										data-aos=""
										/>
										</div>
								<div data-aos="">
								<h5>X-Ray flourescense</h5>
									<p>
									X-ray fluorescence (XRF) is a technique used to analyze the elemental composition of materials. It's particularly useful for identifying and quantifying elements like gold, platinum, and silver. It's commonly used to test the purity of gold and determine its karatage.

									</p>
								
							</div>
							</div>
							<div className="point" data-aos-delay="" data-aos="">
							<div data-aos="">
									<img
										alt="Raman_Spectroscopy_xhpnaz.webp"
										data-src={"https://res.cloudinary.com/ggi/image/upload/v1637903436/Raman_Spectroscopy_xhpnaz.webp"}
										className="machine lazy"
										data-aos=""
									/>
								</div>
								<div>
									<h5>Raman Spectroscopy</h5>
									<p>
									Raman spectroscopy is a technique used to identify and differentiate between gemstones.
                              It can distinguish between natural and synthetic emeralds, diamonds, moissanite, and cubic zirconia. Additionally, it can differentiate between Type A and Type B jadeite jade.   

									</p>
								</div>
								
							</div>
						</div>
					
							{/* <img
								alt="Diamond__Round-Rotating_txrmlp.webp"
								data-src={"https://res.cloudinary.com/ggi/image/upload/v1637903415/Diamond__Round-Rotating_txrmlp.webp"}
								data-aos="zoom-in "
								className="lazy"
							/> */}
						
						<div className="rightPoint col-md-6 col-sm-12">
							<div className="point" data-aos-delay="" data-aos="">
								<div>
									<h5>FTIR</h5>
									<p>
									Fourier Transform Infrared Spectroscopy (FTIR) is a technique used to identify and analyze materials based on their molecular structure. It's particularly useful for distinguishing between natural and synthetic gemstones, detecting treatments like polymer impregnation in jade and emeralds, and classifying diamonds based on their type and any treatments they may have undergone.

									</p>
								</div>
								<div>
									<img
										alt="FTIR_mdxn94.webp"
										data-src={"https://res.cloudinary.com/ggi/image/upload/v1637903422/FTIR_mdxn94.webp"}
										className="machine lazy"
										data-aos=""
									/>
								</div>
							</div><br/>
							<div className="point" data-aos-delay="" data-aos="">
								<div>
									<h5>Delta XRF (X-Ray Fluorescence)</h5>
									<p>
									Delta XRF is a technique used to analyze the elemental composition of materials.
									It's particularly useful for determining the precise composition of alloys, identifying metals, minerals, and contaminants, and analyzing the elemental makeup of rocks, soil, and mineral samples.   
									</p>
								</div>
								<div>
									<img
										alt="Delta_XRF_iwbzxe.webp"
										data-src={"https://res.cloudinary.com/ggi/image/upload/v1637903389/Delta_XRF_iwbzxe.webp"}
										className="machine lazy"
										data-aos=""
									/>
																	</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
const mapStateToProps = ({ store }) => ({});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Home);
